import main from './fr/main';
import errors from './fr/errors';
import formats from './fr_MU/formats';

export default { ...main, ...errors, ...formats };
